import React from "react";
import { Box, IconButton, Typography, Link, Divider, Button } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import { Link as RouterLink } from "react-router-dom";

// Versión de la interfaz de usuario
const UI_VERSION = "1.3.6";

export default function Footer() {
  // const { openTerms } = useContext(TermsContext); // Eliminada porque no se usa
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        textAlign: "center",
        mt: "auto",
        background: (theme) => theme.palette.primary.main,
        color: "common.white",
        backdropFilter: "blur(8px)",
      }}
    >
      <Box sx={{ 
        display: "flex", 
        justifyContent: "center", 
        gap: 2,
        mb: 2
      }}>
        <IconButton 
          component="a" 
          href="https://www.instagram.com/ganaconbendicionenmanos" 
          target="_blank" 
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              transform: "scale(1.1)",
            },
            transition: "all 0.3s ease",
            width: 48,
            height: 48,
            "& .MuiSvgIcon-root": {
              color: "#FFFFFF",
            },
          }}
        >
          <InstagramIcon sx={{ fontSize: 28 }} />
        </IconButton>
      </Box>

      <Box sx={{ 
        display: "flex", 
        justifyContent: "center", 
        gap: 2,
        mb: 2
      }}>
        <Button
          component="a"
          href="https://wa.me/584263911161?text=Hola%2C%20requiero%20informaci%C3%B3n%20sobre%20las%20rifas"
          target="_blank"
          startIcon={<WhatsAppIcon />}
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            color: "success.main",
            "&:hover": {
              color: "success.main",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              transform: "scale(1.05)",
            },
            transition: "all 0.3s ease",
            borderRadius: "20px",
            px: 3,
          }}
        >
          Soporte WhatsApp
        </Button>
        <Button
          component="a"
          href="mailto:ganaconbendicionenmanos@gmail.com"
          startIcon={<EmailIcon />}
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            color: "white",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              transform: "scale(1.05)",
            },
            transition: "all 0.3s ease",
            borderRadius: "20px",
            px: 3,
          }}
        >
          Soporte Email
        </Button>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Button
          component={RouterLink}
          to="/terms"
          sx={{
            color: "common.white",
            textShadow: "0 0 2px rgba(0,0,0,0.8)",
            "&:hover, &:focus": {
              color: "common.blue",
              textShadow: "0 0 2px rgba(0,0,0,0.8)",
            },
          }}
        >
          Términos y Condiciones
        </Button>
      </Box>
      
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
        <Box
          component="img"
          src="/assets/images/conalot-logo.png"
          alt="CONALOT"
          sx={{
            height: 40,
            filter: "brightness(0) invert(1)",
            opacity: 0.9,
            transition: "opacity 0.3s ease",
            "&:hover": {
              opacity: 1,
            },
          }}
        />
        <Typography
          variant="body2"
          sx={{
            color: "common.white",
            textShadow: "0px 1px 2px rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          Desarrollado por{" "}
          <Link
            href="https://pixeocreativestudio.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "common.white",
              textDecoration: "none",
              fontWeight: 500,
              position: "relative",
              transition: "all 0.3s ease",
              "&:after": {
                content: '""',
                position: "absolute",
                width: "100%",
                height: "2px",
                bottom: -2,
                left: 0,
                backgroundColor: "white",
                transform: "scaleX(0)",
                transformOrigin: "bottom right",
                transition: "transform 0.3s ease-out",
                boxShadow: "0 0 8px rgba(255,255,255,0.5)",
              },
              "&:hover": {
                color: "common.blue",
                textShadow: "0 0 8px rgba(255, 255, 255, 0.5)",
                transform: "translateY(-1px)",
                "&:after": {
                  transform: "scaleX(1)",
                  transformOrigin: "bottom left",
                },
              },
            }}
          >
            Pixeo Creative Studio
          </Link>
        </Typography>
      </Box>
      
      <Divider sx={{ 
        my: 1, 
        borderColor: "rgba(255,255,255,0.2)",
        width: "80%",
        mx: "auto",
      }} />
      
      <Typography
        variant="body2"
        sx={{
          color: "common.white",
          fontWeight: 300,
          textShadow: "0px 1px 2px rgba(255, 255, 255, 0.7)",
          mt: 1,
        }}
      >
        © {new Date().getFullYear()} GANA CON BENDICION EN MANOS. Todos los derechos reservados.
      </Typography>
      
      <Box sx={{ 
        display: "flex", 
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "center", 
        alignItems: "center", 
        gap: 2,
        mt: 1,
        px: 2,
      }}>
        <Typography
          variant="caption"
          sx={{
            color: "rgba(255, 255, 255, 0.6)",
            textShadow: "0px 1px 2px rgba(0, 0, 0, 0.7)",
          }}
        >
          Versión {UI_VERSION}
        </Typography>
      </Box>
    </Box>
  );
}
